import styled from "styled-components";

export const BannerContainer = styled.div.attrs({})`
  position: relative;
  aspect-ratio: 94 / 32;
  background: url(${props => props.bgImage}) center/cover no-repeat;
  display: flex;
  align-items: center;
  transition: background-image 0.8s ease-in-out;
  flex: 1;
  @media (max-width: 718px) {
    aspect-ratio: 16 / 14;
    
    background-size: cover;
  }
`;

export const PlayedVideos = styled.video.attrs({
})`            
  width: 100%;
`;

export const Container = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PlayerShell = styled.div.attrs({})`
  position: relative;
  width: 100%;
  min-height: ${p => p.minHeight || '360px'};
  aspect-ratio: 16 / 9;
  background: ${p => p.theme.palette.colors.backgroundStrong};
  border-radius: 18px;
  overflow: hidden;
  isolation: isolate;

  @media (max-width: 991px) {
    min-height: 0;
  }
`;

export const PlayerLayer = styled.div.attrs({})`
  position: absolute;
  inset: 0;
  z-index: 1;
  opacity: ${p => p.visible ? 1 : 0};
  transition: opacity 0.28s ease;

  video,
  wistia-player,
  iframe {
    width: 100%;
    height: 100%;
    display: block;
  }

  wistia-player {
    border-radius: 0 !important;
  }
`;

export const EndScreenLayer = styled.div.attrs({})`
  position: absolute;
  inset: 0;
  z-index: 4;
`;

export const PlayerPlaceholder = styled.div.attrs({})`
  position: absolute;
  inset: 0;
  z-index: 0;
  opacity: ${p => p.hidden ? 0 : 1};
  transition: opacity 0.28s ease;
  background:
    linear-gradient(180deg, ${p => p.theme.palette.colors.cardOverlayStart} 0%, ${p => p.theme.palette.colors.cardOverlayMiddle} 55%, ${p => p.theme.palette.colors.cardOverlayEnd} 100%),
    ${p => p.theme.palette.colors.surface};
`;

export const PlaceholderImage = styled.img.attrs({})`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const PlaceholderGlow = styled.div.attrs({})`
  position: absolute;
  inset: auto 0 0 0;
  height: 42%;
  background: linear-gradient(180deg, ${p => p.theme.palette.colors.cardOverlayStart} 0%, ${p => p.theme.palette.colors.cardOverlayEnd} 100%);
`;

export const FallbackVideo = styled.video.attrs({})`
  width: 100%;
  height: 100%;
  display: block;
  background: ${p => p.theme.palette.colors.background};
`;

export const Content = styled.div.attrs({})`
  padding: 16px;
  border-radius: 0px 0px 8px 8px;
  background: ${p => p.theme.palette.colors.white};
  margin-top: -4px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TextContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ContentContainer = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Title = styled.div.attrs({})`
  color: ${p => p.theme.palette.colors.black};
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
    h1{
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
  }
`;

export const OptionsIcon = styled.div.attrs({})`
  padding: 7px 6px;
  background: ${p => p.theme.palette.colors.lightBlue};
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: fit-content;
`;
